import {
  Device,
  DeviceGroupDto,
  Pagination,
  VariableDataResult,
  VariableSourceSettingsDto,
  VariableSourceSettingsMutatePayload,
  VariableSourceSettingsType,
} from '@thingslog/repositories';
import { AxiosResponse } from 'axios';
import Axios from '../../../clients/Axios/Axios';

export class VariableSourceSettingsFactory {
  public static toMutatePayload(
    source: VariableSourceSettingsDto
  ): VariableSourceSettingsMutatePayload {
    const { id, ...rest } = source;
    return rest;
  }

  public static async execute(
    type: VariableSourceSettingsType,
    companyId?: number | null
  ): Promise<VariableDataResult | null> {
    switch (type) {
      case 'device-numbers':
        return this.deviceNumbersExecute(companyId);
      case 'device-groups':
        return this.deviceGroupsExecute(companyId);
      default:
        throw new Error('Unsupported variable source type');
    }
  }

  private static async deviceNumbersExecute(
    companyId?: number | null
  ): Promise<VariableDataResult | null> {
    try {
      // Fetch all devices with a large page size to get all devices
      // In a real-world scenario, you might want to implement pagination
      const response: AxiosResponse<Pagination<Device>> = await Axios.get(`/api/v2/devices`, {
        params: {
          page: 0,
          size: 9999, // Large size to get all devices
          companyId: companyId ?? null,
        },
      });

      if (response.status === 200) {
        const devices = response.data.content;

        const result: VariableDataResult = {
          result: devices.map((device: Device) => ({
            name: device.name || device.number,
            value: device.number,
          })),
        };

        return result;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching devices for variable source:', error);
      throw error;
    }
  }

  private static async deviceGroupsExecute(
    companyId?: number | null
  ): Promise<VariableDataResult | null> {
    try {
      // Fetch all device groups
      const response: AxiosResponse<DeviceGroupDto[]> = await Axios.get(`/api/v2/device-groups`, {
        params: {
          companyId: companyId ?? null,
        },
      });

      if (response.status === 200) {
        const deviceGroups = response.data;

        const result: VariableDataResult = {
          result: deviceGroups.map((group: DeviceGroupDto) => ({
            name: group.deviceGroupName,
            value: group.deviceGroupId.toString(),
          })),
        };

        return result;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching device groups for variable source:', error);
      throw error;
    }
  }
}
